import React from 'react';
import {  Outlet, useNavigate } from "react-router-dom";
import { Grid } from '@mui/material';
import Header from './header';
import Footer from './footer';

const LoginedBase = (props) => { 
    const navigate = useNavigate();
    return (
        <React.Fragment>
            <Header {...props}/>
            <Grid sx={{marginTop: "117px"}}>
                {props.children}
            </Grid>
            <Footer />
        </React.Fragment>
    )
}

export default LoginedBase;